import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentResult.css';

const PaymentError = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/shop');
  };

  const handleSupport = () => {
    window.location.href = 'mailto:info@seedxpert.com?subject=Ödeme Problemi';
  };

  return (
    <div className="payment-result-container">
      <div className="payment-result-content">
        <div className="error-section">
          <div className="error-icon">
            <i className="fas fa-times-circle"></i>
          </div>
          <h1>Ödeme Başarısız</h1>
          <p>Maalesef ödemeniz tamamlanamadı.</p>
          
          <div className="error-details">
            <div className="detail-item">
              <span className="detail-label">Hata Kodu:</span>
              <span className="detail-value">{searchParams.get('error_code') || 'UNKNOWN'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Durum:</span>
              <span className="detail-value error-status">Başarısız</span>
            </div>
          </div>

          <div className="error-message">
            <h3>Ne yapabilirsiniz?</h3>
            <ul>
              <li>Kart bilgilerinizi kontrol edip tekrar deneyebilirsiniz</li>
              <li>Farklı bir ödeme yöntemi deneyebilirsiniz</li>
              <li>Sorun devam ederse destek ekibimizle iletişime geçin</li>
            </ul>
          </div>

          <div className="action-buttons">
            <button className="primary-btn" onClick={handleRetry}>
              Tekrar Dene
            </button>
            <button className="secondary-btn" onClick={handleSupport}>
              Destek Al
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;
